var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',_vm._g(_vm._b({staticClass:"taro-skel-img",scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('div',{staticClass:"taro-img-skeleton"})]},proxy:true}])},'v-img',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }